import createAPI from '../axios'

// 客户管理 API
const sqlCreater = {
    mysql: {
        import: config => createAPI('/mysqlCreater/import', 'post', config),
    }
};

export default sqlCreater;



// WEBPACK FOOTER //
// ./src/api/modules/sqlCreater.js